import { UserInfo } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getCurrentUser: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<UserInfo> = (fetchContext, accessToken) => fetch(`${fetchContext.baseUrl}/api/me`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<UserInfo>(fetchContext.errorStore, response, 'get current user'));
